import {EventTypes} from '@shared-library';
import {CallbackPayload} from '../fasten/callback-payload';
import {ConnectPayload} from '../fasten/connect-payload';
import { SearchQueryPayload } from '../fasten/search-query-payload';

export class MessageBusEventPayload {
  api_mode: "live" | "test"
  event_type: EventTypes
  data: ConnectPayload | CallbackPayload | CallbackPayload[] | SearchQueryPayload;
}
